import React from 'react';

import BrunoMenu from './BrunoMenu';
import PublicMenu from './PublicMenu';

type Props = { isNotLoggedInMarketerUser: boolean };

const NavigationMenu = ({ isNotLoggedInMarketerUser }: Props): JSX.Element => {
  if (isNotLoggedInMarketerUser) {
    return <PublicMenu />;
  }

  return <BrunoMenu />;
};

export default NavigationMenu;
